var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBedtemp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6 12.0008C8.25413 12.0008 9.6 10.6549 9.6 9.00078C9.6 7.34666 8.25413 6.00078 6.6 6.00078C4.94588 6.00078 3.6 7.34666 3.6 9.00078C3.6 10.6549 4.94588 12.0008 6.6 12.0008ZM19.8 7.20078H11.4C11.0685 7.20078 10.8 7.46928 10.8 7.80078V13.2008H2.4V5.40078C2.4 5.06928 2.1315 4.80078 1.8 4.80078H0.6C0.2685 4.80078 0 5.06928 0 5.40078V18.6008C0 18.9323 0.2685 19.2008 0.6 19.2008H1.8C2.1315 19.2008 2.4 18.9323 2.4 18.6008V16.8008H21.6V18.6008C21.6 18.9323 21.8685 19.2008 22.2 19.2008H23.4C23.7315 19.2008 24 18.9323 24 18.6008V11.4008C24 9.08103 22.1198 7.20078 19.8 7.20078Z",
    fill: "#A48111"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedtemp);
export default __webpack_public_path__ + "static/media/bedtemp.714c8e274beb34688abb2d54470f0d78.svg";
export { ForwardRef as ReactComponent };